// extracted by mini-css-extract-plugin
module.exports = {"deliveryDetailsText":"AddressDeliveryDetails_deliveryDetailsText__eKqHc"};